import RelativeSumGameAnsweringBlock from "./RelativeSumGameAnsweringBlock";
import RelativeSumGameKeyboard from "./RelativeSumGameKeyboard";
import GamesContentLayout from "../../../layouts/games/GamesContentLayout";
import GamesTopBar from "../../../bars/games/GamesTopBar";

export default function RelativeSumGameContent({currentQuestion, currentScore, userSign, userAnswer, gameTimeLeft, onKeyPressed}) {
    // Used in MultiplicationGameScreen to handle core game
    // content made of top bar, answering block and
    // keyboard

    // BUILD
    return (
        <div className={"bg-backgroundLight3 h-[100svh] w-full flex flex-col justify-center items-center"}>
            <GamesContentLayout>
                <GamesTopBar currentScore={currentScore}
                             gameTimeLeft={gameTimeLeft} />
                <RelativeSumGameAnsweringBlock
                    currentQuestion={currentQuestion}
                    userSign={userSign}
                    userAnswer={userAnswer} />
                <RelativeSumGameKeyboard
                    userSign={userSign}
                    userAnswer={userAnswer}
                    onKeyPressed={onKeyPressed} />
            </GamesContentLayout>
        </div>
    );
}